import { getLimitDateFormat } from '../../../../content-composer/src/utils';

export const dateValue = (defaultDate: Date, date?: string, fromAmount?: string, toAmount?: string, from?: boolean) => {
  if (date) {
    return getLimitDateFormat(new Date(date), from);
  }

  if ((fromAmount && parseFloat(fromAmount) > -1) || (toAmount && parseFloat(toAmount) > -1)) {
    return getLimitDateFormat(defaultDate, from);
  }

  return null;
};
